var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInterView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 34C26.3888 34 34 26.3888 34 17C34 7.61116 26.3888 0 17 0C7.61116 0 0 7.61116 0 17C0 26.3888 7.61116 34 17 34Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 18.95C26 19.4 25.1 19.7 24.05 19.85C23.375 18.575 22.025 17.6 20.45 16.925C20.6 16.7 20.75 16.55 20.9 16.325H21.5C23.825 16.25 26 17.675 26 18.95ZM13.1 16.25H12.5C10.175 16.25 8 17.675 8 18.95C8 19.4 8.9 19.7 9.95 19.85C10.625 18.575 11.975 17.6 13.55 16.925L13.1 16.25ZM17 17C18.65 17 20 15.65 20 14C20 12.35 18.65 11 17 11C15.35 11 14 12.35 14 14C14 15.65 15.35 17 17 17ZM17 17.75C13.925 17.75 11 19.7 11 21.5C11 23 17 23 17 23C17 23 23 23 23 21.5C23 19.7 20.075 17.75 17 17.75ZM21.275 15.5H21.5C22.775 15.5 23.75 14.525 23.75 13.25C23.75 11.975 22.775 11 21.5 11C21.125 11 20.825 11.075 20.525 11.225C21.125 11.975 21.5 12.95 21.5 14C21.5 14.525 21.425 15.05 21.275 15.5ZM12.5 15.5H12.725C12.575 15.05 12.5 14.525 12.5 14C12.5 12.95 12.875 11.975 13.475 11.225C13.175 11.075 12.875 11 12.5 11C11.225 11 10.25 11.975 10.25 13.25C10.25 14.525 11.225 15.5 12.5 15.5Z",
    fill: "#5382BA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterView);
export default __webpack_public_path__ + "static/media/interView.31d0d1fa2c0523d8185ca7c886774b71.svg";
export { ForwardRef as ReactComponent };